module.exports = __webpack_public_path__ + "img/4@3x.712a5243.png";